import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Container as ContainerIcon,
  Map,
  FileText,
  Tag,
  type LucideIcon,
} from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const ITEMS: { id: string; to: string; icon: LucideIcon; labelKey: string }[] = [
  { id: 'dashboard', to: '/app/dashboard', icon: LayoutDashboard, labelKey: 'nav.dashboard' },
  { id: 'containers', to: '/app/containers', icon: ContainerIcon, labelKey: 'nav.containers' },
  { id: 'map', to: '/app/map', icon: Map, labelKey: 'nav.map' },
  { id: 'bills', to: '/app/bills', icon: FileText, labelKey: 'nav.bills' },
  { id: 'offers', to: '/app/offers', icon: Tag, labelKey: 'nav.offers' },
];

export function BottomNav() {
  const { t } = useLanguage();
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav">
      {ITEMS.map((it) => {
        const Icon = it.icon;
        const active = pathname.startsWith(it.to);
        return (
          <NavLink
            key={it.id}
            to={it.to}
            className={'bn-item' + (active ? ' active' : '')}
          >
            <Icon size={22} strokeWidth={1.8} />
            <span>{t(it.labelKey)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
